import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getTools, type ToolDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useTools(): UseQueryResult<ToolDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.tools(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getTools({ signal }).then((result) => result.data),
    });
}
